export const ATTRIBUTE_MODELS = [
  { id: 0, key: 'CONVERSATION' },
  { id: 1, key: 'CONTACT' },
  { id: 2, key: 'TASK' },
  // 3 on Pro: the task attribute took 2 before upstream gave it to companies.
  { id: 3, key: 'COMPANY' },
];

export const ATTRIBUTE_TYPES = [
  { id: 0, key: 'TEXT' },
  { id: 1, key: 'NUMBER' },
  { id: 4, key: 'LINK' },
  { id: 5, key: 'DATE' },
  { id: 6, key: 'LIST' },
  { id: 7, key: 'CHECKBOX' },
];
